import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { NoticiasService } from 'src/app/services/noticias.service';
import { Router, RouterLink } from '@angular/router';
import { take } from 'rxjs/operators';
import { HomeService } from '@services/home.service';
import { GoogleComponent } from '@pages/utils/google.component';
import { HeaderComponent } from '../../components/header/header.component';
import { BotaoChatComponent } from '../../components/botao-chat/botao-chat.component';
import { IndecxSurfeyComponent } from '../../components/indecx-surfey/indecx-surfey.component';
import { ChatBotComponent } from '../../components/chat-bot/chat-bot.component';
import { BreadcrumbComponent } from '../../components/breadcrumb/breadcrumb.component';
import { TagManagerDirective } from '../../directives/tag-manager.directive';
import { AutoReadjustmentContractComponent } from '../auto-readjustment-contract/auto-readjustment-contract.component';
import { FormsModule } from '@angular/forms';
import { FooterComponent } from '../../components/footer/footer.component';
import { CurrencyPipe } from '@angular/common';
import { AppDatePipe } from '../../pipes/app-date.pipe';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [HeaderComponent, BotaoChatComponent, IndecxSurfeyComponent, ChatBotComponent, BreadcrumbComponent, RouterLink, TagManagerDirective, AutoReadjustmentContractComponent, FormsModule, FooterComponent, CurrencyPipe, AppDatePipe]
})
export class HomeComponent extends GoogleComponent implements OnInit {

  private idEmpresaLogada: any;
  public noticias: any = null;
  public historicoPedidos: any;
  public inputBusca = '';

  private readonly sectionApp = 'painel-de-controle';
  private readonly screenName = 'painel-de-controle:home';
  private readonly screenType = 'pagina';

  constructor(
    private readonly service: NoticiasService,
    public router: Router,
    private readonly homeService: HomeService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.idEmpresaLogada = localStorage.idEmpresaLogada;
    window.scroll(0, 0);
    this.getAllNoticias();
    this.gethistoricoPedidos();
    this.pushScreenView(this.sectionApp, this.screenName, this.screenType);
  }

  addTagManagerInteraction(elementType: string, elementContent: string) {
    return this.buildTagInteraction(elementType, elementContent, this.sectionApp, this.screenName, this.screenType);
  }

  getAllNoticias() {
    this.service.getAllNoticias(this.idEmpresaLogada, '', '', '', '').pipe(take(1)).subscribe({
      next: (response: any) => {
        if (response.response) {
          if (response.response.data.length >= 2) {
            this.noticias = response.response.data.slice(0, 3);
          } else if (response.response.data.length > 0) {
            this.noticias = response.response.data;
          }
        } else {
          this.noticias = [];
        }
      },
      error: () => { this.noticias = false; }
    });
  }

  detalharNoticias(idNoticia: number) {
    this.router.navigate(['noticias-detalhes'], { queryParams: { idNoticia } });
  }

  buscaNoticias() {
    sessionStorage.noticiaInputBuscaFiltro = this.inputBusca;
    this.router.navigate(['noticias']);
  }

  gethistoricoPedidos() {
    this.homeService.getHistoricoPedidos(this.idEmpresaLogada).pipe(take(1)).subscribe({
      next: (response: any) => {
        if (response.response) {
          this.historicoPedidos = response.response.slice(0, 5);
        }
      },
      error: (error: any) => { console.error(error); }
    });
  }

}
